import { defineComponent as _defineComponent } from 'vue'
import { RawLocation } from 'vue-router';
import { useRouter } from 'vue-router/composables';
import AmountDisplay from '@/app/components/wallets/AmountDisplay.vue';
import { ClientRiskProfileReport } from 'ah-api-gateways';
import { computed, onBeforeMount, ref } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useTradeState } from 'ah-trades';


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitsAndCollateralDashboardWidget',
  props: {
    redirectTo: null
  },
  setup(__props: any) {

const props = __props as {
  redirectTo: RawLocation;
};



const tradeState = useTradeState();

const onBehalfOf = useOnBehalfOf();

const router = useRouter();

const requestManager = useRequestManager().manager;

const clientRiskProfileReportData = ref<ClientRiskProfileReport>();

const clientId = computed(
  () => onBehalfOf.value?.id ?? tradeState.store.useAuthStore().loggedInIdentity?.client?.id ?? ''
);

const currency = computed(
  () =>
    clientRiskProfileReportData.value?.limitsProfile?.currency ??
    clientRiskProfileReportData.value?.collateralProfile?.currency ??
    clientRiskProfileReportData.value?.creditProfile?.currency ??
    'GBP'
);

function loadClientRiskProfileReport() {
  if (!clientId?.value && !onBehalfOf?.value) {
    throw 'Cannot load client risk profile report with incomplete data';
  }

  requestManager
    .sameOrNew(
      'loadClientRiskProfileReport',
      tradeState.services.risk.getClientRiskProfile({
        clientId: clientId.value,
        oboClientId: onBehalfOf.value?.id ?? '',
      })
    )
    .subscribe((response) => {
      clientRiskProfileReportData.value = response;
    });
}

onBeforeMount(loadClientRiskProfileReport);

function goToLimitsAndCollateral() {
  router.push(props.redirectTo);
}

return { __sfc: true,props, tradeState, onBehalfOf, router, requestManager, clientRiskProfileReportData, clientId, currency, loadClientRiskProfileReport, goToLimitsAndCollateral, AmountDisplay }
}

})